import { createStore } from "vuex";

import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

import startPage from "./modules/start-page";
import auth from "./modules/auth";
import location from "./location";
import company from "./modules/company";
import administrator from "./modules/administrator";

export default createStore({
  state,
  actions,
  mutations,
  getters,

  modules: {
    [administrator.consts.STORE_PATH]: administrator,
    [company.consts.STORE_PATH]: company,
    [startPage.consts.STORE_PATH]: startPage,
    [auth.consts.STORE_PATH]: auth,
    location,
  },
});